import React from 'react';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';
import CollectsBuysStaticsContainer from '../../containers/collects-buys-statics/CollectsBuysStaticsContainer';

const CollectsBuysStaticsViewPage = () => {
  return (
    <div>
      <BreadcrumbsContainer
        title="채권&채무 관리/수금&지급 통계"
        icon="bonds_dept"
      />
      <CollectsBuysStaticsContainer />
    </div>
  );
};

export default CollectsBuysStaticsViewPage;
